import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { CommonProps } from 'src/components/helpers/props';

export interface IProps extends CommonProps {
  size?: 'md' | 'sm' | 'lg';
  fill?: string;
}

const RequestCompleteIcon: React.FC<IProps> = ({ classes, size = 'md', fill }) => {
  return (
    <svg
      className={classNames('icon-root', classes)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      color="#B5BBC2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25 1.56C7.25 1.25072 7.4552 1 7.70833 1H12.2917C12.5448 1 12.75 1.25072 12.75 1.56V3.24C12.75 3.54928 12.5448 3.8 12.2917 3.8H7.70833C7.4552 3.8 7.25 3.54928 7.25 3.24V1.56Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2.5H6V3.5C6 4.32843 6.67157 5 7.5 5H12.5C13.3284 5 14 4.32843 14 3.5V2.5H14.5C15.8807 2.5 17 3.61929 17 5V16.5C17 17.8807 15.8807 19 14.5 19H5.5C4.11929 19 3 17.8807 3 16.5V5C3 3.61929 4.11929 2.5 5.5 2.5ZM13.5979 9.78145C13.8914 9.45122 13.8617 8.94557 13.5315 8.65203C13.2012 8.3585 12.6956 8.38824 12.402 8.71847L8.99946 12.5464L7.59745 10.9717C7.30364 10.6417 6.79796 10.6124 6.46797 10.9062C6.13799 11.2 6.10866 11.7057 6.40247 12.0357L8.40247 14.2819C8.55435 14.4525 8.7719 14.5501 9.00029 14.55C9.22869 14.5499 9.44615 14.4522 9.59789 14.2815L13.5979 9.78145Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RequestCompleteIcon;
